/* eslint-disable no-unused-vars */
import React from 'react';

export const MXS = {
  ok:      { col:'#22c55e', bc:'bg',  lbl:'OK'       },
  due_soon:{ col:'#d29922', bc:'by',  lbl:'Due Soon'  },
  due:     { col:'#f97316', bc:'bo',  lbl:'Due'       },
  overdue: { col:'#f85149', bc:'br',  lbl:'Overdue'   },
};

export function TB({ s }) {
  const cfg = {
    current: { bg:'rgba(34,197,94,.1)',  c:'#22c55e', b:'rgba(34,197,94,.2)',  l:'Current'  },
    late:    { bg:'rgba(248,81,73,.1)',   c:'#f85149', b:'rgba(248,81,73,.2)',   l:'Late'     },
    notice:  { bg:'rgba(210,153,34,.1)', c:'#d29922', b:'rgba(210,153,34,.2)', l:'Notice'   },
    former:  { bg:'rgba(139,148,158,.1)',c:'#8b949e', b:'rgba(139,148,158,.2)',l:'Former'   },
    active:  { bg:'rgba(34,197,94,.1)',  c:'#22c55e', b:'rgba(34,197,94,.2)',  l:'Active'   },
  }[s] || { bg:'rgba(139,148,158,.1)', c:'#8b949e', b:'rgba(139,148,158,.2)', l:s||'—' };
  return <span style={{ background:cfg.bg, color:cfg.c, border:'1px solid '+cfg.b, padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700, whiteSpace:'nowrap' }}>{cfg.l}</span>;
}

export function MB({ s }) {
  const cfg = {
    open:        { bg:'rgba(248,81,73,.1)',   c:'#f85149', b:'rgba(248,81,73,.2)',   l:'Open'        },
    in_progress: { bg:'rgba(210,153,34,.1)', c:'#d29922', b:'rgba(210,153,34,.2)', l:'In Progress'  },
    resolved:    { bg:'rgba(34,197,94,.1)',  c:'#22c55e', b:'rgba(34,197,94,.2)',  l:'Resolved'     },
  }[s] || { bg:'rgba(139,148,158,.1)', c:'#8b949e', b:'rgba(139,148,158,.2)', l:s||'—' };
  return <span style={{ background:cfg.bg, color:cfg.c, border:'1px solid '+cfg.b, padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700, whiteSpace:'nowrap' }}>{cfg.l}</span>;
}

export function PB({ s }) {
  const cfg = {
    paid:    { bg:'rgba(34,197,94,.1)',  c:'#22c55e', b:'rgba(34,197,94,.2)',  l:'Paid'    },
    unpaid:  { bg:'rgba(248,81,73,.1)',  c:'#f85149', b:'rgba(248,81,73,.2)',  l:'Unpaid'  },
    partial: { bg:'rgba(210,153,34,.1)',c:'#d29922', b:'rgba(210,153,34,.2)', l:'Partial' },
    refunded:{ bg:'rgba(88,166,255,.1)',c:'#58a6ff', b:'rgba(88,166,255,.2)', l:'Refunded'},
  }[s] || { bg:'rgba(139,148,158,.1)', c:'#8b949e', b:'rgba(139,148,158,.2)', l:s||'—' };
  return <span style={{ background:cfg.bg, color:cfg.c, border:'1px solid '+cfg.b, padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700, whiteSpace:'nowrap' }}>{cfg.l}</span>;
}

const Badges = { TB, MB, PB, MXS };
export default Badges;
